import { combineReducers, configureStore } from "@reduxjs/toolkit"
import storage from "redux-persist/lib/storage"
import userReducer from "./slices/userSlice"
import layoutSlice from "./slices/layoutSlice"
import commonSlice from "./slices/commonSlice"

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"
import { setupListeners } from "@reduxjs/toolkit/query"
import api from "./api"

const persistConfig = {
  version: 1,
  storage,
}

const persistedUserReducer = persistReducer(
  { ...persistConfig, key: "user" },
  userReducer
)
const layoutReducer = persistReducer(
  { ...persistConfig, key: "layout" },
  layoutSlice
)
const commonReducer = persistReducer(
  { ...persistConfig, key: "common" },
  commonSlice
)

const rootReducer = combineReducers({
  user: persistedUserReducer,
  layout: layoutReducer,
  common: commonReducer,
  [api.reducerPath]: api.reducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware),
})

setupListeners(store.dispatch)

export const persistor = persistStore(store)
